export default __webpack_public_path__ + "static/media/connect_with_vscode.c4056403.webp";